import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Features = () => {
  const { t } = useLanguage();
  
  const apkUrl = 'https://expo.dev/artifacts/eas/5xguG1EpDELXbKzQw8eseM.apk';

  return (
    <section id="download" className="section-padding bg-white">
      <div className="container-max">
        <div className="max-w-4xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              {t('download.title')}
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              {t('download.subtitle')}
            </p>
          </div>
          
          {/* Download Card */}
          <div className="bg-gradient-to-br from-prayer-red to-prayer-red-dark rounded-2xl p-8 sm:p-10 shadow-xl">
            <div className="flex flex-col md:flex-row md:items-center gap-8">
              <div className="flex-1 text-white">
                <h3 className="text-xl sm:text-2xl font-bold mb-3">
                  {t('features.joinBetaCommunity')}
                </h3>
                <p className="text-white/90 leading-relaxed mb-6">
                  {t('features.betaDescription')}
                </p>
                <p className="text-white/95 font-medium">
                  {t('features.shareApp')}
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href={apkUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-white text-prayer-red font-bold rounded-xl shadow-lg hover:shadow-xl hover:bg-white/95 transition-all duration-200"
                >
                  <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                  </svg>
                  <div className="text-left">
                    <div className="text-xs text-prayer-red/80">{t('features.downloadApk')}</div>
                    <div>{t('features.betaApk')}</div>
                  </div>
                </a>
                <div className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-white/10 text-white/80 rounded-xl border border-white/20">
                  <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,21.95 6.8,20.76 5.96,19.5C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z"/>
                  </svg>
                  <div className="text-left">
                    <div className="text-xs">{t('features.comingSoon')}</div>
                    <div className="font-semibold">{t('features.appStore')}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features; 